// --- Fusion Variant + Collection Add to Cart ---
console.log("CustomJS Loaded");

// universal handler for both singles + collection ATC
function fusionAddHandler(e) {
  const btn = e.target.closest(".vr-add-btn, .atc-standard-btn"); 
  if (!btn) return;

  // SAFETY CHECK: Prevent double-clicks while already adding
  if (btn.classList.contains("loading")) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
  }

  e.preventDefault();
  e.stopImmediatePropagation();  // block Empire quickbuy

  const id = btn.dataset.variantId;
  
  // Add visual feedback immediately (locks the button)
  btn.classList.add("loading"); 

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: id, quantity: 1 })
  })
  .then(() => {
    btn.classList.remove("loading"); // Unlock button
    btn.classList.add("added");
    window.openCartDrawer();    // open drawer immediately
  })
  .catch(err => {
    btn.classList.remove("loading"); // Unlock even if error
    console.error("Add error:", err);
  });
}

// Attach in capture mode so theme scripts can't block it
// FIXED: Removed 'mousedown' listener to prevent double-firing
document.addEventListener("click", fusionAddHandler, true);


// --- Drawer Functions ---
window.openCartDrawer = function () {
  const drawer = document.querySelector("#ajax-cart-drawer");
  const overlay = document.querySelector(".ajax-cart-overlay");

  if (!drawer || !overlay) return;

  drawer.classList.add("active");
  overlay.classList.add("active");

  fetch('/?sections=ajax-cart')
    .then(r => r.json())
    .then(data => {
      const cartBody = document.querySelector("#ajax-cart-body");
      cartBody.innerHTML = data["ajax-cart"];

      // NEW: Check for "No Ship" tag in the rendered items
      // We look for any element in the drawer that might mention No Ship
      const hasNoShip = cartBody.innerText.toLowerCase().includes("no ship") || 
                        cartBody.innerText.toLowerCase().includes("pickup only");

      const checkoutBtn = document.querySelector(".drawer-checkout-btn");
      if (hasNoShip && checkoutBtn) {
        checkoutBtn.style.backgroundColor = "#E65100";
        checkoutBtn.innerText = "Local Pickup Checkout";
      }
    });
};


// Close drawer
window.closeCartDrawer = function () {
  document.querySelector("#ajax-cart-drawer")?.classList.remove("active");
  document.querySelector(".ajax-cart-overlay")?.classList.remove("active");
};


// --- AJAX CART: Quantity Change & Remove ---
document.addEventListener("click", function(e) {
  
  // qty buttons
  const qtyBtn = e.target.closest(".ajax-cart-qty-btn");
  if (qtyBtn) {
    const line = qtyBtn.dataset.line;
    const change = parseInt(qtyBtn.dataset.qtyChange);

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: change })
    })
    .then(() => window.openCartDrawer());

    return; // stop further handler execution
  }

  // remove button
  const remove = e.target.closest(".ajax-cart-remove");
  if (remove) {
    const line = remove.dataset.line;

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(() => window.openCartDrawer());
  }
});

document.querySelector("#floating-cart-button")
  ?.addEventListener("click", () => openCartDrawer()); // Added optional chaining '?' just in case

  // --- CLICK TO CLOSE DRAWER (X button or overlay) ---
document.addEventListener("click", function(e) {
  // Anything with data-cart-close attribute closes the drawer
  if (e.target.closest("[data-cart-close]")) {
    window.closeCartDrawer();
  }
});

// --- ESCAPE KEY CLOSES CART DRAWER ---
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    window.closeCartDrawer();
  }
});

// --- HEADER CART BUTTON OPENS SLIDEOUT CART ---
document.addEventListener("click", function (e) {
  const headerCartBtn = e.target.closest(".site-header-cart--button");

  if (headerCartBtn) {
    e.preventDefault();           // stop navigation to /cart
    e.stopPropagation();          // block theme default handlers
    window.openCartDrawer();      // open your AJAX drawer
  }
});


// --- Fetch Store Credit (Customer Account API) ---
async function loadStoreCredit() {
  if (!window.Shopify || !Shopify.customer) return;

  try {
    const res = await fetch('/account/credit-balance');

    if (!res.ok) return;

    const data = await res.json();

    if (data && data.balance) {
      const el = document.getElementById('store-credit-amount');
      if (el) el.innerText = Shopify.formatMoney(data.balance);
    }
  } catch (err) {
    console.error('Store credit fetch failed:', err);
  }
}

// Refresh credit when drawer opens
document.addEventListener("click", function(e) {
  if (e.target.closest(".site-header-cart--button")) {
    setTimeout(loadStoreCredit, 300);
  }
});


// --- Remove All Items ---
document.addEventListener("click", function(e) {
  const btn = e.target.closest("#drawer-remove-all");
  if (!btn) return;

  fetch("/cart/clear.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" }
  })
  .then(() => {
    // Reload drawer content
    window.openCartDrawer();
  });
});